import axios from "axios";

import { ITotalBookingsDashboard } from "../../pages/dashboard/types";

export const getTotalBookingsDashboard = async (req: { tenants: string[], dealers: string[] }): Promise<ITotalBookingsDashboard> => {
    const params = new URLSearchParams();
    params.set("tenants", req.tenants.join(","));
    params.set("dealers", req.dealers.join(","));
    const response = await axios.get('/booking/dashboard', { params });
    return response.data;
};
